// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__w2M0x","content":"LoadingAlert_content__1y39O"};